import { Vue } from "vue-class-component";
import authBloc from "../../services/bloc";
import guard from "@/guard";
import { loading, alertError } from "@cems-eco/core/src/utils/widget";
import { ElLoading } from "element-plus";

export default class AuthAutoLoginPage extends Vue {
  bloc = authBloc;
  async beforeCreate() {
    const loader = ElLoading.service({ lock: true, text: "Authenticating" });
    try {
      const platform: string = this.$route.params.platform as string;
      const token: string = this.$route.query.token as string;
      const response: any = await this.bloc.autoLogin(platform, token);
      await this.bloc.saveStorage(response);
      await guard.checkAuthentication();
      loader.close();
    } catch (e) {
      loader.close();
      console.log(e);
      alertError(e);
    }
  }
}
